import { RouteRecordRaw } from 'vue-router'
import { constantRoutes, defaultRoutes } from '../constantRoutes'
import { menuSyncRoute, mobileMenuSyncRoute } from '../staticModules'

/**
 * 动态路由：菜单路由来自后台权限配置，子模块 routes.ts 不在此加载
 * （仅保留 menu-sync 路由，方便随时同步菜单）
 */
const layoutRoute = constantRoutes.find((r) => r.path === '/') as RouteRecordRaw

const layoutChildren: RouteRecordRaw[] = [
  ...(layoutRoute.children || []),
  menuSyncRoute,
  mobileMenuSyncRoute
]

const dynamicRouter: RouteRecordRaw[] = [
  {
    ...layoutRoute,
    children: layoutChildren
  },
  ...constantRoutes.filter((r) => r.path !== '/'),
  ...defaultRoutes
]

export default dynamicRouter
